import { Link } from 'react-router-dom'
import netzence from '../../images/Frame 2147228713.png'
import image1 from '../../images/datawithSS.png'
import image2 from '../../images/traffic.png'
import image3 from '../../images/sus1.png'
import Header from '../shared/Header'
import Footer from '../shared/Footer'
import sportlight from '../../images/SSwithAxeela.png'
function BlogPost9() {

     const blogs = [
    {
      id: 1,
      badge: "Clean Transport",
      badgeColor: "#006633",
      title: "Netzence set to unveil clean mobility hailing App in June 2026",
      description: "At a time when Nigeria’s cities are expanding at an unprecedented pace, and the strain on urban systems is becoming increasingly visible, e, a quiet but critical shift is beginning to take shape...",
      source: "25/03/2026",
      image: image1,
      readMoreLink: "#"
    },
    {
      id: 2,
      badge: "Clean Transport",
      badgeColor: "#006633",
      title: "2026 Climate Mobility Horizon: Nigeria’s New Income Engine  Netzence",
      description: "Nigeria is facing a potential silent public-health emergency – one that does not announce itself with sirens or breaking news...",
      source: "06/01/2026",
      image: image2,
      readMoreLink: "#"
    },
    {
      id: 3,
      badge: "Global Footprint Network",
      badgeColor: "#00AED9",
      title: "Netzence partners with Ministry of Livestock, Germany’s GIZ to conduct livestock monitoring capacity-building",
      description: "Netzence Sustainability Limited (Netzence) has taken a significant step toward strengthening...",
      source: "30/12/2025",
      image: image3,
      readMoreLink: "#"
    }
  ];
  return (
<>

<Header/> 
<Link to="/blogs">
<div className='ml-72 text-[14px] flex pt-20'>
    Return to blog
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.5 18L15.5 12L9.5 6" stroke="#898989" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


</div>
</Link>
<div className='ml-72 text-[24px] font-bold'>Netzence, Axxela partner to drive Nigeria’s carbon credit economy</div>
<div className='ml-72 flex gap-5 mt-10 '>
    <img src={netzence} alt="netzence" className='w-[48px]'></img>


    <div>
        <div className='text-[16px] mb-3'>
            Netzence 
        </div>
        <div className='flex items-center gap-3 '>
            December 28, 2025 <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="3" cy="3" r="3" fill="#898989"/>
</svg>
4 mins read
        </div>
    </div>


</div>
<div className='ml-72 mr-72 mt-20'>
    <img src={sportlight} alt="spotlight" className='object-fill w-[1200px]'></img>
</div>

 <div className="flex flex-col items-start gap-4 w-full max-w-[1152px] h-auto mt-20 ml-72" >
      {/* Paragraph 1 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Nigeria’s foremost green technology innovator, Netzence Sustainability Limited, has concluded plans to harmonise economic growth with environmental stewardship at a time when global attention is fixed on climate action and energy transition.</p>
      {/* Paragraph 2 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
The firm stated this while entering into a transformative partnership with Axxela Limited, a leading gas and power company.</p>

      {/* Paragraph 3 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
This landmark Memorandum of Understanding was signed under the leadership of Axxela’s Acting Group Chief Executive Officer, Mr Timothy Ononiwu.</p>

      {/* Paragraph 4 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Speaking on the development, the Founder and CEO of Netzence, Dr Sadiq, said: “Carbon credits and green financing mechanisms present a tremendous opportunity for Nigeria to diversify its economy while reducing emissions. By monetising carbon reduction initiatives, businesses can unlock new revenue streams, create jobs, and attract sustainable investments—ultimately positioning Nigeria as a leader in Africa’s green economy.”</p>

      {/* Paragraph 5 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Also speaking, Axxela’s Group Chief Executive Officer, Mr Ononiwu, said: “With the infrastructure that many customers invest in, Netzence has deployed a laudable innovation to help bolster data for irrefutable value as firms quest to validate carbon offsetting.</p>

      {/* Paragraph 6 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
On his part, Dr Sani said: “Axxela provided support to Netzence and aided in the development of CloseCarbon Technology, by allowing Netzence complete its Proof of Concept at its facility in Cadbury Nigeria Plc – in Lagos.</p>

      {/* Paragraph 7 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
“Nigeria’s vast natural resources, including renewable energy potential, make it an ideal candidate for carbon offset projects. With the right policies and private-sector collaboration, we can turn climate action into an economic catalyst, benefiting agriculture and manufacturing industries. The green economy is not just about saving the planet—it’s about creating wealth, fostering innovation, and ensuring long-term prosperity for Nigeria. The time to act is now.” His words were both a rallying cry and a sober reminder of the urgent need for concerted action on climate and energy challenges.” </p>     {/* Paragraph 8 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Meanwhile, Ononiwu said: “Sustainability is no longer optional; it is a business imperative,” he asserted, capturing the evolving mindset of forward-thinking Nigerian corporations. “This collaboration allows our customers to integrate smarter, cleaner energy solutions into their operations while supporting Nigeria’s broader climate goals.” </p>     {/* Paragraph 8 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
The signing was attended by Axxela’s Acting Group Chief Executive Officer (Acting GCEO) – Mr. Timothy Ononiwu, Touyo Ejueyitchie – Director of Corporate Operations, Kehinde Alabi – Managing Director, AxxelaGas Distribution, Eromosele Agboighale – Head, Sales and Marketing, Onabokun Ayoola – Financial Controller, John Okoro – Head Environmental, Health, Safety and Sustainability, , Faith Ehiemere EHSS, Oluwaseun Salami EHSS and from Netzence Sustainability Limited – Dr. Sadiq Sani – Founder/CEO, Idia Okundaye – Chief Operations Officer, Mr Awwal Abdullahi – General Manager</p>
      {/* Paragraph 8 */}
      <p className=" font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Source</p>
      {/* Paragraph 8 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Netzence, Axxela partner to drive Nigeria’s carbon credit economy</p>
      {/* Paragraph 8 */}
     
      {/* Paragraph 12 */}

    </div>

   <div className="items-start gap-10 w-full max-w-[1200px] h-[43px] ml-72">
        <h2 
          className="text-[#0D924F] font-bold text-4xl leading-[43px] w-[225px] h-[43px]"
          style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
        >
          Related Blogs
        </h2>
      </div>

     <div className=" items-start gap-10 w-full max-w-[1201px] h-auto mt-20 ">
      {/* Header */}
   
      {/* Cards Container */}
      <div className="flex flex-row items-stretch gap-8 w-full flex-wrap ml-72 lg:flex-nowrap mb-20">
        {blogs.map((blog) => (
          <div 
            key={blog.id}
            className="flex flex-col items-center pb-6 gap-4 w-[379px] h-[544px] bg-white shadow-[0px_8px_24px_rgba(149,157,165,0.2)] rounded-2xl shrink-0"
          >
            {/* Image */}
            <div className="w-[378px] h-[282px] rounded-t-2xl overflow-hidden">
              <img 
                src={blog.image} 
                alt={blog.title}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Article Content */}
            <div className="flex flex-col items-start gap-4 w-[352px] h-[222px]">
              {/* Badge */}
              <div 
                className="flex flex-row justify-center items-center px-1.5 py-0.5 gap-2 h-[25px] rounded"
                style={{ backgroundColor: blog.badgeColor }}
              >
                <span 
                  className="text-white font-medium text-[14px] leading-[21px]"
                  style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
                >
                  {blog.badge}
                </span>
              </div>

              {/* Text Container */}
              <div className="flex flex-col items-start gap-3 w-full">
                {/* Title */}
                <h3 
                  className="text-[#3B3B3B] font-semibold text-[20px] leading-[24px] tracking-[-0.02em] w-full"
                  style={{ 
                    fontFamily: "'Inter', sans-serif",
                    fontFeatureSettings: "'cv01' on, 'cv03' on, 'cv04' on"
                  }}
                >
                  {blog.title}
                </h3>
                
                {/* Description */}
                <p 
                  className="text-[#898989] font-normal text-[14px] leading-[20px] w-full"
                  style={{ 
                    fontFamily: "'Inter', sans-serif",
                    fontFeatureSettings: "'cv03' on, 'cv04' on"
                  }}
                >
                  {blog.description}
                </p>
              </div>

              {/* Footer */}
              <div className="flex flex-row justify-between items-center w-full">
                <span 
                  className="text-[#3B3B3B] font-normal text-[14px] leading-[21px]"
                  style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
                >
                  {blog.source}
                </span>
                
                <a 
                  href={blog.readMoreLink}
                  className="flex flex-row justify-center items-center gap-2 transition-all duration-150 hover:opacity-80 group"
                >
                  <span 
                    className="text-[#006633] font-medium text-[14px] leading-[20px]"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    Read More
                  </span>
                  <div className="relative w-2.5 h-4 flex items-center justify-center">
                    <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 1L6.5 6L1.5 11" stroke="#006633" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
<Footer/>
</>
  )
}

export default BlogPost9